<template>
  <div class="gt-root">
    <div
      class="gt-dialog"
      role="dialog"
      aria-modal="true"
      aria-label="AI text">
      <div class="gt-header">
        <span
          class="gt-icon"
          aria-hidden="true">
          <icon name="sparkle"/>
        </span>
        <div class="gt-copy">
          <h2>Generate text</h2>
          <p v-if="!showResults">Writes new copy for the selected text box.</p>
          <p v-else>Pick a variation to replace the selected text.</p>
        </div>
      </div>

      <div class="gt-body">
        <template v-if="!showResults">
          <div class="gt-field">
            <label
              class="gt-label"
              for="gt-prompt">Enter a prompt to generate text</label>
            <textarea
              id="gt-prompt"
              v-model="prompt"
              :class="{ 'is-invalid': showTxtErr }"
              class="gt-textarea"
              @input="showTxtErr = false"
            />
            <div
              v-if="showTxtErr"
              class="gt-error"
              role="alert">
              <icon name="alert-circle"/>
              <span> Please enter at least 3 characters.</span>
            </div>
          </div>

          <div class="gt-field">
            <div class="gt-label">Select the number of variations</div>
            <div
              class="gt-variations"
              role="group"
              aria-label="Select the number of variations">
              <button
                v-for="count in variationCounts"
                :key="count"
                :aria-label="variationLabel(count)"
                :aria-pressed="Number(variations) === count ? 'true' : 'false'"
                :title="variationLabel(count)"
                :class="{ 'is-active': Number(variations) === count }"
                type="button"
                class="gt-variation"
                @click="variations = count">
                <span>{{ count }}</span>
              </button>
            </div>
          </div>
        </template>

        <div
          v-else
          class="gt-results">
          <div class="gt-prompt">
            <icon name="pencil"/>
            <span>“{{ prompt }}”</span>
          </div>
          <div
            v-for="(text, index) in texts"
            :key="index"
            class="gt-result">
            <span class="gt-index">{{ padIndex(index) }}</span>
            <p
              class="gt-result-text"
              v-html="text" />
            <button
              type="button"
              class="gt-insert"
              @click="updateText(text)">
              <icon name="plus"/>
              Insert
            </button>
          </div>
        </div>

        <Spinner
          v-show="isLoading"
          :speed="1"
          size="small"
          message="Loading..."
          class="inner-Loader"/>
      </div>

      <div class="gt-footer">
        <span class="gt-spacer"/>
        <button
          type="button"
          class="gt-btn is-outline"
          @click="$store.commit('activeProduct/updateShowTextAiGenModal', false)">
          Cancel
        </button>
        <button
          v-if="!isLoading && !showResults"
          type="button"
          class="gt-btn is-solid"
          @click="generateText">
          <icon name="sparkle"/>
          Generate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from 'vue-simple-spinner';
import EventBus from '../../EventBus';
import ApplicationEventTypes from '../../mixins/ApplicationEventTypes';
import Icon from '../Icon/Icon.vue';

export default {
  components: { Icon, Spinner },
  data() {
    return {
      showResults:     false,
      prompt:          '',
      variations:      1,
      texts:           [],
      isLoading:       false,
      resultShown:     0,
      showTxtErr:      false,
      variationCounts: [1, 2, 3, 4],
    };
  },
  methods: {
    variationLabel(count) {
      return `${count} variation${count === 1 ? '' : 's'}`;
    },
    padIndex(index) {
      const number = index + 1;
      return number < 10 ? `0${number}` : String(number);
    },
    generateText() {
      if (this.prompt.length < 3) {
        this.showTxtErr = true;
        return;
      }

      const self               = this;
      const urlSearchPart      = window.location.search;
      const newUrlSearchParams = new URLSearchParams(urlSearchPart);
      const userId             = newUrlSearchParams.has('userId')
        ? newUrlSearchParams.get('userId')
        : '21d29854-fb88-45e6-9a12-b1f4e6c67d45';

      const domainUrl = this.$store.getters.getBMCInstance === 'marketingcenter.source4'
        ? this.$store.getters.getBMCInstance
        : `www.${this.$store.getters.getBMCInstance}`;

      const numberofVariations = parseInt(this.variations, 10) || 1;

      // clear previous results
      self.texts       = [];
      this.showResults = false;
      this.isLoading   = true;
      self.resultShown = 0;
      let { prompt }   = this;
      prompt           = prompt.replaceAll('&', 'and');

      if (numberofVariations === 1) {
        const postingUrl = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetAiResponse&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/&userId=${userId}&userInput=${encodeURIComponent(`${prompt}


        Generate above text, and just provide plain texts. `)}&numberOfVariations=1`;

        axios.post(postingUrl)
          .then((response) => {
            if (response.data) {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(response.data, 'text/xml');

              const result = xmlDoc
                .getElementsByTagName('GetAiResponseResult')[0]
                .textContent.trim();

              const sentences = result
                .split('\n')
                .map(line => line.trim())
                .filter(line => /^\d+\./.test(line));

              const cleanSentences = sentences.map(line => line.replace(/^\d+\.\s*/, ''));

              self.texts.push(result);


              this.isLoading = false;

              this.showResults = true;
            } else {
              alert('No response data');
            }
          })
          .catch((e) => {
            console.error('Error fetching variation:', e);
          });
      } else {
        // const postingUrl = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetAiResponse&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/&userId=${userId}&userInput=${encodeURIComponent(`${prompt}


        // Generate above text, create only ${numberofVariations} number of differnt variation, provide them in numbered list and just provide plain texts. and dont write anything else. `)}&numberOfVariations=1`;

        const postingUrl = `${this.$store.getters.getBaseUrl}/web_service.aspx?method=GetAiResponse&bankId=${this.$store.getters.getBankId}&domainURL=https://${domainUrl}.com/&userId=${userId}&userInput=${encodeURIComponent(`${prompt}

As an assistant, reply with short explanations in a few lines. give me ${numberofVariations} variations and remember to use number list, and just provide plain texts only and you donot have to add something from your side like explanations and all and donot use dashes`)}&numberOfVariations=1`;

        axios.post(postingUrl)
          .then((response) => {
            if (response.data) {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(response.data, 'text/xml');

              const result = xmlDoc
                .getElementsByTagName('GetAiResponseResult')[0]
                .textContent.trim();

              console.log('result', result);

              const sentences = result
                .trim()
                .split(/\d+\.\s+/) // split by "1. ", "2. ", etc.
                .filter(Boolean);

              sentences.forEach((item) => {
                self.texts.push(item);
              });


              this.isLoading   = false;
              this.showResults = true;
            } else {
              alert('No response data');
            }
          })
          .catch((e) => {
            console.error('Error fetching variation:', e);
          });
      }
    },

    updateText(text) {
      EventBus.$emit(ApplicationEventTypes.Canvas.UPDATE_TEXT_FROM_AI, text.split(/\n\s*\n/) // split on blank lines
        .map(p => `<p>${p.trim()}</p><br>`)
        .join(''));
      this.$store.commit('activeProduct/updateShowTextAiGenModal', false);
      EventBus.$emit('addIntoPageWiseUndoRedoArray', 'From AI Text');
    },
    isSubdomain(url) {
      url         = `https://${url}.com`;
      const regex = new RegExp(/^([a-z]+\:\/{2})?([\w-]+\.[\w-]+\.\w+)$/);
      return !!url.match(regex); // make sure it returns boolean
    },
  },
};
</script>

<style lang="scss" scoped>
.gt-root {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(2px);
  font-family: 'Geist', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: #14161B;
  -webkit-font-smoothing: antialiased;
}

.gt-dialog {
  position: relative;
  width: 800px;
  max-width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 0 0 1px rgba(16, 24, 40, 0.06), 0 24px 64px rgba(16, 24, 40, 0.22);
  overflow: hidden;
}

.gt-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px 0;
}

.gt-icon {
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #EAF2FE;
  color: #0B57C2;
}

.gt-copy h2 {
  margin: 0;
  font-family: inherit;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
  color: #14161B;
}

.gt-copy p {
  margin: 2px 0 0 !important;
  font-size: 12.5px;
  font-weight: 400;
  line-height: 1.4;
  color: #5E6573;
}

.gt-body {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px 24px 20px;
}

.gt-label {
  display: block;
  margin: 0 0 8px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #14161B;
}

.gt-textarea {
  display: block;
  width: 100%;
  box-sizing: border-box;
  height: 96px;
  resize: vertical;
  padding: 10px 12px;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: inset 0 0 0 1px #E7E9ED;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  color: #14161B;
  outline: 0;
}

.gt-textarea,
.gt-textarea:focus,
.gt-btn,
.gt-btn:focus,
.gt-variation,
.gt-variation:focus,
.gt-insert,
.gt-insert:focus {
  border: 0;
  outline: 0;
  -webkit-appearance: none;
  appearance: none;
}

.gt-textarea:focus {
  box-shadow: inset 0 0 0 1.5px #1570EF, 0 0 0 3px rgba(21, 112, 239, 0.15);
}

.gt-textarea.is-invalid,
.gt-textarea.is-invalid:focus {
  box-shadow: inset 0 0 0 1.5px #D92D20;
}

.gt-error {
  display: flex;
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.3;
  color: #D92D20;
  align-items: center;
  gap: 2px;
  justify-items: center;
}

.gt-variations {
  width: 220px;
  display: flex;
  gap: 2px;
  padding: 3px;
  background: #F3F4F6;
  border-radius: 10px;
  min-width: 0;
}

.gt-variation {
  flex: 1 1 0;
  height: 32px;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #3D4350;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 500;
  cursor: pointer;
}

.gt-variation:hover:not(.is-active) {
  color: #14161B;
}

.gt-variation.is-active {
  background: #fff;
  color: #0B57C2;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1), 0 0 0 1px #E7E9ED;
}

.gt-results {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-height: calc(100vh - 280px);
  overflow-y: auto;
}

.gt-prompt {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 12.5px;
  line-height: 1.4;
  color: #5E6573;
}

.gt-prompt span {
  min-width: 0;
}

.gt-result {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 14px 14px 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: inset 0 0 0 1px #E7E9ED;
}

.gt-index {
  flex-shrink: 0;
  padding-top: 3px;
  font-family: 'Geist Mono', ui-monospace, 'SF Mono', Menlo, monospace;
  font-size: 11.5px;
  line-height: 1.4;
  color: #5E6573;
}

.gt-result-text {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0 !important;
  font-size: 15px;
  line-height: 1.55;
  color: #14161B;
  white-space: pre-wrap;
  text-wrap: pretty;
}

.gt-insert {
  height: 32px;
  min-height: 32px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 11px;
  border: 0;
  border-radius: 9px;
  background: #1570EF;
  color: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.gt-insert:hover {
  background: #0B57C2;
}

.gt-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 24px;
  border-top: 1px solid #E7E9ED;
  background: #FBFBFC;
}

.gt-spacer {
  flex: 1 1 auto;
}

.gt-btn {
  height: 38px;
  min-height: 38px;
  min-width: 72px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 14px;
  border: 0;
  border-radius: 9px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.gt-btn.is-outline {
  background: #fff;
  color: #14161B;
  box-shadow: inset 0 0 0 1px #D5D9E0;
}

.gt-btn.is-outline:hover {
  background: #F3F4F6;
}

.gt-btn.is-solid {
  background: #1570EF;
  color: #fff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.12);
}

.gt-btn.is-solid:hover {
  background: #0B57C2;
}

.gt-icon ::v-deep .icon,
.gt-btn ::v-deep .icon,
.gt-prompt ::v-deep .icon,
.gt-insert ::v-deep .icon {
  min-width: 0;
  min-height: 0;
  flex-shrink: 0;
}

.gt-icon ::v-deep svg {
  display: block;
  width: 18px;
  height: 18px;
}

.gt-prompt ::v-deep svg {
  display: block;
  width: 14px;
  height: 14px;
}

.gt-btn ::v-deep svg,
.gt-insert ::v-deep svg {
  display: block;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.inner-Loader {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(255, 255, 255, 0.72);
}
</style>
